import React from 'react';
export function Header() {
  return <header className="w-full py-8 px-6 md:px-12 border-b border-transparent" data-id="element-16">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-17">
        <div className="text-2xl tracking-wide font-medium" data-id="element-18">Cosmiclevel</div>
        <nav className="hidden md:block" data-id="element-19">
          <ul className="flex space-x-8 text-sm uppercase tracking-widest font-sans text-gray-500" data-id="element-20">
            <li data-id="element-21">Exhibition</li>
            <li data-id="element-22">Artists</li>
            <li data-id="element-23">Visit</li>
          </ul>
        </nav>
      </div>
    </header>;
}